import React from 'react';
import PropTypes from 'prop-types';
import { AIcon } from './';

export default class AIconButton extends React.Component {
	constructor(props) {
		super(props);

		this.state = { active: props.active };
		this.handleClick = this.handleClick.bind(this);
	}

	componentWillReceiveProps(props) {
		if (props.active !== this.state.props) {
			this.setState({ active: props.active });
		}
	}

	handleClick() {
		this.setState({ active: !this.state.active });
		this.props.onClick();
	}

	render() {
		const iconClass = Array.from(this.props.iconClassName).includes('no-color') ? 'white' : '';
		const active = this.state.active ? 'active' : '';

		return (
			<button className={`a-icon-button ${this.props.className}`} onClick={this.handleClick}>
				<div className="icon-wrapper">
					<AIcon type={this.props.type} className={`${iconClass} ${active}`} />
				</div>
			</button>
		);
	}
}

AIconButton.propTypes = {
	className: PropTypes.string,
	iconClassName: PropTypes.string,
	type: PropTypes.string,
	onClick: PropTypes.func,
	active: PropTypes.bool,
};

AIconButton.defaultProps = {
	className: '',
	iconClassName: '',
	onClick: null,
	type: '',
	active: false,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.icon-button.js